import { create } from '@bufbuild/protobuf'
import type { ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { AreaCode } from '@ebalance/proto/bfftypes/v1/area_pb'
import { Side } from '@ebalance/proto/bfftypes/v1/side_pb'
import { SupplyCategory } from '@ebalance/proto/bfftypes/v1/supply_category_pb'
import { listSupply48Data } from '@ebalance/proto/bffuser/v1/supply_48_data_service-Supply48DataService_connectquery'
import {
  ListSupply48DataRequestSchema,
  type ListSupply48DataResponse,
} from '@ebalance/proto/bffuser/v1/supply_48_data_service_pb'
import type { Date as ProtoDate } from '@ebalance/proto/google/type/date_pb'
import type { UseQueryResult } from '@tanstack/react-query'

export type ListSupply48DataFilter = {
  buySell: Side
  category: SupplyCategory
  areaCode: AreaCode
  dateFrom?: ProtoDate
  dateTo?: ProtoDate
  /**
   * §8: personalSettings ロード完了 + area 確定まで fetch を抑止するオーバーライド。
   * false のとき fetch しない。省略時はデフォルト条件 (area/date 確定) で判定する。
   */
  enabled?: boolean
}

/**
 * 48 点データ一覧を取得する React Query フック。
 */
export function useListSupply48Data(
  filter: ListSupply48DataFilter,
): UseQueryResult<ListSupply48DataResponse, ConnectError> {
  const req = create(ListSupply48DataRequestSchema, {
    buySell: filter.buySell,
    category: filter.category,
    areaCode: filter.areaCode,
    dateFrom: filter.dateFrom,
    dateTo: filter.dateTo,
  })

  const defaultEnabled =
    filter.buySell !== Side.UNSPECIFIED &&
    filter.category !== SupplyCategory.UNSPECIFIED &&
    filter.areaCode !== AreaCode.UNSPECIFIED &&
    filter.dateFrom !== undefined &&
    filter.dateTo !== undefined

  return useQuery(listSupply48Data, req, {
    // §8: enabled prop でオーバーライド可能。未指定時はデフォルト条件を使う
    enabled:
      filter.enabled !== undefined
        ? filter.enabled && defaultEnabled
        : defaultEnabled,
  })
}
